<mat-drawer-container appSidebarToggle class="admin-container material-profile-colors" autosize>
  <mat-drawer #drawer class="admin-sidenav" mode="side" [opened]="true">
    <header [title]="'Profile'"></header>

    <mat-nav-list>
      <mat-list-item
        [routerLink]="['/Profile/EditProfile']"
        [class.nav-active]="(currentUrl | stringContains: 'EditProfile')"
        matTooltip="Edit Profile"
      >
        Edit Profile
      </mat-list-item>
      <mat-divider></mat-divider>
      <mat-list-item
        [routerLink]="['/Profile/ChangePassword']"
        [class.nav-active]="currentUrl | stringContains: 'ChangePassword'"
        matTooltip="Change Password"
      >
        Change Password
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-nav-list>
  </mat-drawer>

  <div class="admin-content-layout" id="content">
    <div class="content">
      <button class="menu-trigger d-block d-md-none" mat-raised-button (click)="drawer.toggle()"><mat-icon svgIcon="menu"></mat-icon></button>
      <router-outlet></router-outlet>
    </div>
  </div>
</mat-drawer-container>
